/**
 * Disable Input Handler
 *
 * Allows checkboxes/inputs with .disable-input class to control
 * the disabled state of other form fields.
 *
 * Usage:
 * <input type="checkbox" class="disable-input" data-disable="field1,field2" id="controller">
 * <input type="text" id="field1">
 * <input type="text" id="field2">
 *
 * Add .disable-reversed class for inverse logic (checked = enabled)
 */
const initDisableInputHandler = () => {
    $(document).on('change', '.disable-input', function() {
        const $el = $(this);
        const shouldReverse = $el.hasClass('disable-reversed');
        const inputId = $el.attr('id')?.replace('hidden_', '') || '';
        const disableData = $el.data('disable');

        if (!disableData) return;

        const inputsToDisable = disableData.split(',').map(s => s.trim());

        for (let i = 0; i < inputsToDisable.length; i++) {
            const selector = inputsToDisable[i];
            const $inputToDisable = $('#' + selector);
            const $checkbox = $inputToDisable.parent().find('.disable-input');

            let checkedState = $el.is(':checked');

            if (shouldReverse) {
                checkedState = !checkedState;
            }

            if (checkedState) {
                $inputToDisable.val('').trigger('change');
                $inputToDisable.attr('disabled', 'disabled');

                if ($checkbox.length && !$checkbox.data('disable')?.includes(inputId)) {
                    $checkbox.attr('disabled', 'disabled');
                }
            } else {
                $inputToDisable.removeAttr('disabled');

                if ($checkbox.length) {
                    $checkbox.removeAttr('disabled');
                }
            }
        }
    });

    // Trigger initial state
    $('.disable-input').trigger('change');
};

export default initDisableInputHandler;
